import { render, staticRenderFns } from "./textScroll.vue?vue&type=template&id=e863ddf8&scoped=true"
import script from "./textScroll.vue?vue&type=script&lang=js"
export * from "./textScroll.vue?vue&type=script&lang=js"
import style0 from "./textScroll.vue?vue&type=style&index=0&id=e863ddf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863ddf8",
  null
  
)

export default component.exports